export default "__VITE_ASSET__6941a977__"